import STATE_TYPE from '@/constants/ConstantStateType';
import currency from 'currency.js';

export default class UtilsMask {
  static cnpj(value) {
    if (!value) return '';

    value = value.toString();

    if (value.length === 13) {
      value = '0'.concat(value);
    }

    if (value.length === 8) return value.replace(/\D/g, '').replace(/^(\d{2})(\d{3})?(\d{3})?/, '$1.$2.$3');
    if (value.length === 11) return value.replace(/\D/g, '').replace(/^(\d{3})(\d{3})?(\d{3})?(\d{2})?/, '$1.$2.$3-$4');
    if (value.length === 12) return value.replace(/\D/g, '').replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?/, '$1.$2.$3/$4');
    if (value.length === 14)
      return value.replace(/\D/g, '').replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, '$1.$2.$3/$4-$5');

    return value;
  }

  static cpf(value) {
    if (!value) return '';

    value = value.toString();

    if (value.length === 11) return value.replace(/\D/g, '').replace(/^(\d{3})(\d{3})?(\d{3})?(\d{2})?/, '$1.$2.$3-$4');

    return value;
  }

  static cnae(value) {
    if (!value) return '';

    value = value.toString();

    if (value.length === 3) return value.replace(/\D/g, '').replace(/^(\d{2})(\d{1})?/, '$1.$2');
    if (value.length === 5) return value.replace(/\D/g, '').replace(/^(\d{2})(\d{2})?(\d{1})?/, '$1.$2-$3');
    if (value.length === 7) return value.replace(/\D/g, '').replace(/^(\d{4})(\d{1})?(\d{2})?/, '$1-$2/$3');

    return value;
  }

  static cep(value) {
    if (!value) return '';

    if (value.length === 8) return value.replace(/\D/g, '').replace(/^(\d{5})(\d{3})?/, '$1-$2');

    return value;
  }

  static money(value, precision = 2, symbol = 'R$ ', defaultValue = 'R$ 0,00') {
    if (!value) return defaultValue;

    try {
      return currency(value, { symbol, separator: '.', decimal: ',', precision }).format();
    } catch (e) {
      return value;
    }
  }

  static empty(value) {
    if (!value) return '---';

    return value;
  }

  static statusType(value) {
    if (!value) return value;

    return STATE_TYPE[value] ?? value;
  }

  /**
   * Format a number with thousands separator
   * @param {number} value - The number to format
   * @returns {string} - The formatted number
   */
  static numberWithThousands(value) {
    if (!value) return '';
    return value
      .toString()
      .replace(/\D/g, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  static ctps(value) {
    if (!value) return '';

    value = value.toString().replace(/[^0-9A-Za-z]/g, '');

    if (value.length <= 7) return value.replace(/^(\d{1,7})$/, '$1');
    if (value.length <= 11) return value.replace(/^(\d{7})(\d{1,4})$/, '$1 $2');
    if (value.length > 11) return value.replace(/^(\d{7})(\d{4})([A-Za-z]{0,2}).*/, '$1 $2 $3');

    return value;
  }

  static rg(value) {
    if (!value) return '';

    value = value.toString().replace(/\D/g, '');

    if (value.length <= 2) return value;
    if (value.length <= 5) return value.replace(/^(\d{2})(\d{1,3})$/, '$1.$2');
    if (value.length <= 8) return value.replace(/^(\d{2})(\d{3})(\d{1,3})$/, '$1.$2.$3');
    if (value.length <= 9) return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{1})$/, '$1.$2.$3-$4');

    return value;
  }

  /**
   * Format CAEPF (Cadastro de Atividades Econômicas da Pessoa Física)
   * Format: 000.000.000/000-00
   * @param {string|number} value - The CAEPF value to format
   * @returns {string} - The formatted CAEPF
   */
  static caepf(value) {
    if (!value) return '';

    value = value.toString().replace(/\D/g, '');

    if (value.length === 12) {
      return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3/$4-$5');
    }

    return value;
  }

  /**
   * Format CNO (Cadastro Nacional de Obras)
   * Format: 00.000.00000/00
   * @param {string|number} value - The CNO value to format
   * @returns {string} - The formatted CNO
   */
  static cno(value) {
    if (!value) return '';

    value = value.toString().replace(/\D/g, '');

    if (value.length === 10) {
      return value.replace(/^(\d{2})(\d{3})(\d{5})(\d{2})/, '$1.$2.$3/$4');
    }

    return value;
  }

  /**
   * Format inscription based on type (Tpinsc)
   * 1 = CNPJ, 3 = CAEPF, 4 = CNO
   * @param {string|number} value - The inscription value
   * @param {number} tpinsc - The inscription type
   * @returns {string} - The formatted inscription
   */
  static inscricaoAmbiente(value, tpinsc) {
    if (!value) return '';

    switch (tpinsc) {
      case 'CNO':
        return this.cno(value);
      case 'CAEPF':
        return this.caepf(value);
      case 'CNPJ':
        return this.cnpj(value);
      default:
        return value;
    }
  }
}
